// All modal portals share one interaction/scroll owner. Keep prior DOM state so
// closing a child cannot unlock the page while its parent is still open.
const layers: HTMLElement[] = []
const previousInert = new Map<HTMLElement, boolean>()
let overflow = ''

function sync() {
  previousInert.forEach((value, element) => { element.toggleAttribute('inert', value) })
  previousInert.clear()
  const top = layers[layers.length - 1]
  if (!top) return
  Array.from(document.body.children).forEach(child => {
    if (!(child instanceof HTMLElement) || child === top) return
    previousInert.set(child, child.hasAttribute('inert'))
    child.setAttribute('inert', '')
  })
  layers.forEach((layer, index) => {
    // Contain portaled menus' high z-indices within their owning layer.
    layer.style.position = 'relative'
    layer.style.zIndex = String(50 + index)
    layer.style.setProperty('--modal-offset', `${Math.min(index, 3) * 20}px`)
  })
}

export function registerModalLayer(element: HTMLElement) {
  const returnFocus = document.activeElement as HTMLElement | null
  if (!layers.length) {
    overflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }
  layers.push(element)
  sync()
  const observer = new MutationObserver(sync)
  observer.observe(document.body, { childList: true })
  return () => {
    observer.disconnect()
    layers.splice(layers.indexOf(element), 1)
    sync()
    if (!layers.length) document.body.style.overflow = overflow
    if (returnFocus?.isConnected && !returnFocus.closest('[inert]')) returnFocus.focus()
  }
}

export const isTopModalLayer = (element: HTMLElement | null) =>
  !!element && layers[layers.length - 1] === element
